import { compareUUIDs } from 'uuid-encoding';
import {
  isCompanyServiceRequestHolder,
  type CompanyHolderCandidate,
} from './isCompanyServiceRequestHolder';

export interface ServiceRequestOwners {
  createdBy?: { id?: string | null } | null;
  company?: { id?: string | null } | null;
}

export type ServiceRequestUser = CompanyHolderCandidate & { _id: string };

// submitOnBehalfOf is not the submitter: the server edit check ignores it too
export const canEditOrCancelServiceRequest = (
  user: ServiceRequestUser | null | undefined,
  serviceRequest: ServiceRequestOwners
): boolean =>
  compareUUIDs(serviceRequest.createdBy?.id, user?._id) ||
  isCompanyServiceRequestHolder(user, serviceRequest.company?.id);
